const EMPTY_ARRAY = Object.freeze([]);
const EMPTY_OBJECT = Object.freeze({});
const EMPTY_STRING = Object.freeze("");

export { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING};
